import API_ROOT from '../../../../../utils/api';
import securedAxios from '../../../../../utils/secured-axios';

import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import { MerchantPurchaseConfirmData } from '../../../../../interfaces/merchants/products/purchases/confirm';
import { MerchantPurchaseCustomFieldsData } from '../../../../../interfaces/merchants/products/purchases/custom_fields';
import * as IInputs from '../../../../../interfaces/merchants/products/purchases/inputs';

import { callStripeApi, StripeResponse } from '../../../../../utils/stripe';

import * as b from './apiBodyBuilder';

export const fetchProduct = async (productId: string) => {
  const { data } = await securedAxios.get<IPurchases.MerchantProductData>(
    `${API_ROOT}/products/${productId}`,
  );
  return data;
};

export const fetchCustomFields = async (productId: string) => {
  const { data } = await securedAxios.get<MerchantPurchaseCustomFieldsData>(
    `${API_ROOT}/products/${productId}/custom_fields`,
  );
  return data;
};

export const fetchConfirmation = async (productId: string) => {
  const { data } = await securedAxios.get<MerchantPurchaseConfirmData>(
    `${API_ROOT}/products/${productId}/rules`,
  );
  return data;
};

const inputsToPostStructure = (
  inputs: IInputs.State,
): IPurchases.PurchasingRequestInput => {
  let postObject = {};
  if (inputs.userInfo) {
    const userInfo = b.withUserInfo(inputs.userInfo);
    postObject = { ...postObject, ...userInfo };
  }
  if (inputs.payment) {
    const payment = b.withPayment(inputs.payment);
    postObject = { ...postObject, ...payment };
  }
  return postObject;
};

const _postPurchasing = async (
  url: string,
  reqData: IPurchases.PurchasingRequestData,
): Promise<IPurchases.PurchasingResponseData> => {
  try {
    const { data } = await securedAxios.post<IPurchases.PurchasingResponseData>(
      url,
      reqData,
    );
    return data;
  } catch (e) {
    if (e.response.status === 400) {
      return { ...e.response.data };
    } else {
      return { success: false };
    }
    throw e;
  }
};

const purchasingUrl = (schemeType: IPurchases.SchemeType): string => {
  if (schemeType === IPurchases.SchemeType.Subscription) {
    return `${API_ROOT}/subscriptions`;
  }
  if (schemeType === IPurchases.SchemeType.TicketBook) {
    return `${API_ROOT}/ticket_books`;
  }
  throw new Error(`cannot create url: schemeType ${schemeType}`);
};

export const postPurchasingCustomer = async (
  schemeType: IPurchases.SchemeType,
  productId: string,
  inputs: IInputs.State,
) =>
  _postPurchasing(`${purchasingUrl(schemeType)}/validate/customer`, {
    input: await inputsToPostStructure(inputs),
    product_id: productId,
  });

export const postPurchasingPayment = async (
  schemeType: IPurchases.SchemeType,
  productId: string,
  inputs: IInputs.State,
) =>
  _postPurchasing(`${purchasingUrl(schemeType)}/validate/payment`, {
    input: await inputsToPostStructure(inputs),
    product_id: productId,
  });

export const postPurchasingFinish = async (
  schemeType: IPurchases.SchemeType,
  productId: string,
  inputs: IInputs.State,
) =>
  _postPurchasing(purchasingUrl(schemeType), {
    input: await inputsToPostStructure(inputs),
    product_id: productId,
  });

export const postStripe = async (
  payment: IInputs.Payment,
): Promise<StripeResponse | undefined> => {
  if (payment.selection === IPurchases.PaymentSelection.AnotherCreditCard) {
    // カード選びがない => 利用歴がなく新しいカード生成
    return callStripeApi(payment.creditCard!);
  } else {
    return;
  }
};
